import { Component, Input, OnInit } from '@angular/core';
import { StripeSetupIntentsComponent } from '../stripe-setup-intents/stripe-setup-intents.component';
import { CurrencyPipe, DatePipe, JsonPipe } from '@angular/common';
import { DateLotteryPipe } from '../../../core/pipes/date-lottery.pipe';
import { DateEndLotteryPipe } from '../../../core/pipes/date-end-lottery.pipe';
import { CountdownConfig, CountdownModule } from 'ngx-countdown';
import { FormPaymentStripeComponent } from '../form-payment-stripe/form-payment-stripe.component';

const CountdownTimeUnits: [string, number][] = [
  ['Y', 1000 * 60 * 60 * 24 * 365], // years
  ['M', 1000 * 60 * 60 * 24 * 30], // months
  ['D', 1000 * 60 * 60 * 24], // days
  ['H', 1000 * 60 * 60], // hours
  ['m', 1000 * 60], // minutes
  ['s', 1000], // seconds
  ['S', 1], // million seconds
];

@Component({
    selector: 'app-ranffle',
    imports: [StripeSetupIntentsComponent, JsonPipe, CurrencyPipe, DatePipe, DateLotteryPipe, DateEndLotteryPipe, CountdownModule, FormPaymentStripeComponent],
    templateUrl: './ranffle.component.html',
    styleUrl: './ranffle.component.scss',
    standalone: true
})
export class RanffleComponent implements OnInit {
  @Input() item;
  //  usar el https://docs.stripe.com/api/setup_intents/create
  //  para alamacenar los datos de la tarjeta en stripe y poder hacer el cargo a futuro una ves que ternime la rifa

  // validad si el susario existe en stripe, si no crear un suario de stripe y en etoyrepublic con nombre apellido y email
  // se necetia crear un token
  //  lugo crear un  createPaymentMethod te regresa el id de PM
  config: CountdownConfig;
  notify = false;
  ngOnInit(): void {

    

    const now = new Date().getTime();
    const lastDay = new Date(this.item.date_lottery[0] - 1).setHours(23, 59, 59);
    const time: any = lastDay - now;
    const time2 = time / 1000;

    this.config = {
      leftTime: 1,
      format: 'DD HH:mm:ss',
      timezone: 'GMT-6',
      notify: [1],

      formatDate: ({ date, formatStr }) => {
        let duration = Number(date || 0);

        return CountdownTimeUnits.reduce((current, [name, unit]) => {
          if (current.indexOf(name) !== -1) {
            const v = Math.floor(duration / unit);
            duration -= v * unit;
            return current.replace(new RegExp(`${name}+`, 'g'), (match: string) => {
              // When days is empty
              if (name === 'D' && v <= 0) {
                return '';
              }
              return v.toString().padStart(match.length, '0');
            });
          }
          return current;
        }, formatStr);
      },
    };
  }
  handleEvent(e) {
    this.notify = e.action.toUpperCase();
    if (e.action === 'done') {
      this.notify = true;
    }
    
    
  }


  createToken() { }
  createMethodPayment() { }
  creatUser() { }
  createSetupIntent() { }
}
